import React from 'react';
import ClientePage from '../features/clientes/components/ClientePage';

const Page: React.FC = () => <ClientePage />;

export default Page; 